import React from 'react';

const achievements = [
    {
        id: 1,
        icon: '🌳',
        tag: '家谱同步',
        label: '年度系统稳定性',
        value: '99.9%',
        gradient: 'from-green-500 to-emerald-600',
        bg: 'from-white to-green-50',
        border: 'border-green-100',
        hover: 'from-green-500/5 to-emerald-500/5',
        valueGradient: 'from-green-600 to-emerald-700',
        bar: 'from-green-400 to-emerald-500',
    },
    {
        id: 2,
        icon: '✉️',
        tag: '时光私信',
        label: '延时信息触达率',
        value: '100%',
        gradient: 'from-teal-500 to-cyan-600',
        bg: 'from-white to-teal-50',
        border: 'border-teal-100',
        hover: 'from-teal-500/5 to-cyan-500/5',
        valueGradient: 'from-teal-600 to-cyan-700',
        bar: 'from-teal-400 to-cyan-500',
    },
    {
        id: 3,
        icon: '🔒',
        tag: '数据安全',
        label: '零重大安全事故',
        value: '100%',
        gradient: 'from-blue-500 to-indigo-600',
        bg: 'from-white to-blue-50',
        border: 'border-blue-100',
        hover: 'from-blue-500/5 to-indigo-500/5',
        valueGradient: 'from-blue-600 to-indigo-700',
        bar: 'from-blue-400 to-indigo-500',
    },
    {
        id: 4,
        icon: '🛡️',
        tag: '实名可信',
        label: '可信身份核验技术',
        value: '100%',
        gradient: 'from-purple-500 to-pink-600',
        bg: 'from-white to-purple-50',
        border: 'border-purple-100',
        hover: 'from-purple-500/5 to-pink-500/5',
        valueGradient: 'from-purple-600 to-pink-700',
        bar: 'from-purple-400 to-pink-500',
    },
];

const TechAchievements = () => {
    return (
        <div id="tech" className="bg-gradient-to-br from-gray-50 to-blue-50 py-16 md:py-24">
            <section>
                <div className="container mx-auto px-4 md:px-8">
                    {/* 标题区域 */}
                    <div className="text-center mb-16">
                        <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-6">
                            <span className="text-2xl">🏆</span>
                        </div>
                        <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">技术成就</h2>
                        <div className="w-20 h-1 bg-blue-600 mx-auto mb-6 rounded-full"></div>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                            我们以强大的技术为基石，以用户体验为导向，致力于打造真实可靠的社交平台
                        </p>
                    </div>

                    {/* 成就卡片 */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                        {achievements.map((item, index) => (
                            <div
                                key={item.id}
                                className={`group relative bg-gradient-to-br ${item.bg} rounded-2xl shadow-lg hover:shadow-xl transition-all duration-500 overflow-hidden border ${item.border}`}
                            >
                                <div className={`absolute inset-0 bg-gradient-to-br ${item.hover} opacity-0 group-hover:opacity-100 transition-opacity duration-500`}></div>

                                <div className="p-7 relative text-center">
                                    <div className={`w-14 h-14 mx-auto bg-gradient-to-br ${item.gradient} rounded-xl flex items-center justify-center group-hover:scale-105 transition-transform duration-300 shadow-md mb-5`}>
                                        <span className="text-2xl text-white">{item.icon}</span>
                                    </div>

                                    <h3 className="text-lg font-bold text-gray-800 mb-2">{item.tag}</h3>
                                    <p className="text-sm text-gray-500 mb-4">{item.label}</p>

                                    <p className={`text-4xl font-extrabold bg-gradient-to-r ${item.valueGradient} bg-clip-text text-transparent`}>
                                        {item.value}
                                    </p>
                                </div>

                                <div className={`absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r ${item.bar} transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500`}></div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default TechAchievements;
